import { OrderNoteOptionDto } from '@up/data';

export function getLastCartOrderNoteClickedSequence(
  currentNoteClickedSequence,
  orderNoteOptions: OrderNoteOptionDto[]
) {
  let cartNotesWithClickedSequence = [];
  cartNotesWithClickedSequence = orderNoteOptions.filter((x) => x.clickedSequence);
  cartNotesWithClickedSequence?.forEach((x) => {
    if(x.clickedSequence > currentNoteClickedSequence) {
      currentNoteClickedSequence = x.clickedSequence;
    }
  })

  return currentNoteClickedSequence;
}